export type TokenInfoAction = 'add' | 'remove'

export const TOKEN_INFO_ACTION_LABELS: Record<TokenInfoAction, string> = {
  add: 'Add Token Info',
  remove: 'Remove Token Info',
}

export const TOKEN_INFO_ACTION_DESCRIPTIONS: Record<TokenInfoAction, string> = {
  add: 'Add token information for a specific chain',
  remove: 'Remove token information from a chain',
}
